<template>
  <div class="contentArea">
    <AgGrid />
    <span class="flex justify-end"
      ><p>
        <b>หมายเหตุ***</b>
        หากต้องการ<b>ลบประเภทของหลักสูตร</b>&nbsp;กรุณาตรวจสอบให้แน่ใจว่า<b
          >ประเภทหลักสูตรนั้นไม่มีอยู่ในหลักสูตร</b
        >
      </p></span
    >
  </div>
</template>

<script>
import AgGrid from "../elements/ag-grid-table/AgGridTable.vue";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive",
      page: "general/page"
    })
  },
  async mounted() {
    await this.$store.dispatch("general/getcurriculumtype");
    this.$store.dispatch("general/push_pointer", "curriculumType");
  },
  components: {
    AgGrid
  }
};
</script>

<style lang="scss" scoped></style>
